module.exports = __webpack_public_path__ + "media/Cody_Lohnes.c0a998e1.mp4";